<template>
  <CModal
    :show.sync="surveyAddModal"
    :centered="true"
    title="ارسال پاسخنامه"
    size="md"
  >
    <CForm class="add-homework-modal text-right">
      <CAlert color="info" class="text-sm mt-1">
        بعد از پایان مهلت ارسال به دانش آموز نشان داده می شود.
      </CAlert>

      <CTextarea
        v-model="form.answerText"
        label="توضیحات"
        class="text-sm mt-2"
      />
      <UploadFile
        v-if="surveyAddModal === true"
        v-model="form.answerFiles"
        @upload-file="onUploadAnswerFile"
        cat="HMA"
      />
    </CForm>

    <template #footer>
      <CButton
        :disabled="loading"
        @click="onAddSurvey"
        color="primary"
        class="px-5"
      >
        تایید
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";
import UploadFile from "../../UploadFile/UploadFile.vue";
export default {
  components: {
    UploadFile,
  },
  props: {
    value: {
      type: Boolean,
    },
    homework: {
      typr: Object,
    },
  },
  data() {
    return {
      form: {
        answerFiles: [],
      },
      loading: false,
    };
  },
  computed: {
    surveyAddModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    async onAddSurvey() {
      try {
        this.loading = true;
        const payload = {
          answerText: this.form.answerText,
          answerFiles: this.form.answerFiles,
        };
        await axios.put(
          `/homework/${this.homework.id}/teacher/answer`,
          payload
        );
        this.form = {};
        this.surveyAddModal = false;
        this.$emit("get-homework");
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onUploadAnswerFile(file) {
      this.form.answerFiles = file;
    },
  },
};
</script>

<style lang="scss" scoped>
.survey {
  border-top: 1px solid #9da5b1;
}
</style>
